// src/utils/applicationNotifications.js
import { supabase } from '../supabaseClient';

// Main function used by CulinaryCareerPortal.jsx
export async function sendApplicationNotification(payload) {
  try {
    if (!supabase) {
      console.error('Supabase client is not initialized');
      return { success: false, error: new Error('Supabase client not initialized') };
    }

    // Make sure we always send to both addresses
    const primaryRecipient =
      process.env.REACT_APP_APPLICATIONS_TO_EMAIL || 'postboxno2324@gmail.com';
    const secondaryRecipient =
      process.env.REACT_APP_APPLICATIONS_CC_EMAIL || 'info@primeventuresglobal.com';

    const body = {
      ...payload,
      recipients: [primaryRecipient, secondaryRecipient],
    };

    console.log('📡 Calling Edge Function via supabase.functions.invoke...', body);

    const { data, error } = await supabase.functions.invoke(
      'send-application-email',
      {
        body,
      }
    );

    if (error) {
      console.error('❌ Error from send-application-email Edge Function:', error);
      return { success: false, error };
    }

    console.log('✅ send-application-email response:', data);
    return { success: true, result: data };
  } catch (err) {
    console.error('❌ Unexpected error in sendApplicationNotification:', err);
    return { success: false, error: err };
  }
}